import { useAppStore } from '../stores/useAppStore';

/** Глобальный год планирования: [год, установить]. */
export const usePlanningYear = (): [number, (year: number) => void] => {
  const year = useAppStore((s) => s.planningYear);
  const setYear = useAppStore((s) => s.setPlanningYear);
  return [year, setYear];
};
